import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

// Gates the diagnostic pages behind environment.enableTestPage so they can
// be turned off per-environment (e.g. production) without touching routes.
export const testPageGuard: CanActivateFn = () => {
  if (environment.enableTestPage) {
    return true;
  }
  const router = inject(Router);
  return router.parseUrl('/');
};
